import { QUERY_KEYS } from 'api/query-keys';
import { availabilityService } from 'api/services';
import { WorkersAvailabilityPaginated } from 'api/services/availability/availability-service.schema';
import { DateTime } from 'luxon';
import { useInfiniteQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';

export const useGetAvailableWorkers = (params: {
  search: string | undefined;
  fromDate: DateTime;
  flexPoolIds: string[];
  pageSizeParam: number;
  enabled: boolean;
}) => {
  const { site } = useSiteDetection();

  return useInfiniteQuery<WorkersAvailabilityPaginated, Error>({
    queryKey: QUERY_KEYS.workersAvailability(
      params.search,
      params.fromDate.toISODate(),
      params.flexPoolIds
    ),
    queryFn: async ({ pageParam = 0 }) => {
      return await availabilityService.getWorkersAvailability({
        search: params.search,
        pageSizeParam: params.pageSizeParam,
        fromDate: params.fromDate.toISODate(),
        flexPoolIds: params.flexPoolIds,
        site,
        pageParam,
      });
    },
    enabled: params.enabled,
    cacheTime: CACHE_TIME_LONG,
    staleTime: CACHE_TIME_LONG,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.hasNextPage) {
        return allPages.length;
      }
      return undefined;
    },
  });
};
